import i18n from '@config/i18n/config';
export const CURRENCY_UNITS = [
	{ id: 'USD', label: '$' },
	{ id: 'EUR', label: ' €' },
	{ id: 'GBP', label: '£' },
	{ id: 'JPY', label: '¥' },
	{ id: 'CAD', label: '$' },
	{ id: 'CHF', label: 'Fr' },
	{ id: 'EURperTonne', label: '€/t' },
	{
		id: 'euroPerExVat',
		label: `€ (${i18n.t('global.exclVAT')})`,
	},
];
